import React from "react";
import { useFieldArray } from "react-hook-form";
import { Box, Button, FormHelperText, FormLabel } from "@material-ui/core";

import { makeKey } from "../../../../utils/helpers";

import { useFieldsStyles } from "../fields.styles";

import { FieldArrayProps } from "./field-array.props";

export const FieldArray = (props: FieldArrayProps) => {
  const { buttonText = "Add", FieldArrayField } = props;

  const commonClasses = useFieldsStyles();

  const { fields, append, remove } = useFieldArray({
    control: props.form.control,
    keyName: "key",
    name: `${props.name}` as const,
    shouldUnregister: false,
  });

  const hasError = !!props.form.formState.errors[props.name];
  const errorMessage = props.form.formState.errors[props.name]?.message;

  const onAppend = () => {
    append(props.appendField());
  };

  return (
    <div className={commonClasses.fieldWrapper}>
      <Box display="flex" justifyContent="space-between">
        <FormLabel component="h3" error={hasError} required={props.required}>
          {props.label}
        </FormLabel>
      </Box>

      <div className={props.fieldArrayFieldWrapperClass}>
        {fields.map((field: any, index) => {
          return (
            <FieldArrayField
              {...props}
              key={makeKey(field.key, index)}
              field={field}
              index={index}
              remove={remove}
            />
          );
        })}
      </div>

      <div className={commonClasses.centered}>
        <Button variant="outlined" onClick={onAppend}>
          {buttonText}
        </Button>
      </div>

      {hasError && <FormHelperText error={hasError}>{errorMessage}</FormHelperText>}
    </div>
  );
};
